import { render, staticRenderFns } from "./PreviewFileModal.vue?vue&type=template&id=45b2dd7c&scoped=true"
import script from "./PreviewFileModal.vue?vue&type=script&lang=js"
export * from "./PreviewFileModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileModal.vue?vue&type=style&index=0&id=45b2dd7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2dd7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b2dd7c')) {
      api.createRecord('45b2dd7c', component.options)
    } else {
      api.reload('45b2dd7c', component.options)
    }
    module.hot.accept("./PreviewFileModal.vue?vue&type=template&id=45b2dd7c&scoped=true", function () {
      api.rerender('45b2dd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/PreviewFileModal.vue"
export default component.exports